import React from "react"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { Spacer } from "../atoms/Atoms"
import { FormattedMessage } from "react-intl"
import { H3 } from "@carrotfertility/carotene"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { DbgPaths, Paths } from "../../../utils/Paths"
import { IlloClipboardNoBackground } from "../atoms/Illustrations"

const SupportModule = () => {
  return (
    <>
      <RoundedRectangle backgroundColor="near-white">
        <IlloClipboardNoBackground />
        <Spacer height={0.25} />

        <H3 variant="primary" stack="tiny">
          <FormattedMessage defaultMessage="Before using your funds" />
        </H3>

        <ArrowLink to={DbgPaths.CARROT_ELIGIBLE}>
          <FormattedMessage defaultMessage="Understand your coverage" />
        </ArrowLink>
        <Spacer height={0.25} />

        <ArrowLink to={DbgPaths.PROVIDER_ELIGIBILITY}>
          <FormattedMessage defaultMessage="Make sure your provider is eligible" />
        </ArrowLink>
        <Spacer height={0.25} />

        <ArrowLink to={DbgPaths.REQUIRED_DOCS}>
          <FormattedMessage defaultMessage="Review documentation requirements" />
        </ArrowLink>
        <Spacer height={0.25} />

        <ArrowLink to={DbgPaths.TAXES}>
          <FormattedMessage defaultMessage="Learn about Carrot and taxes" />
        </ArrowLink>
        <Spacer height={0.25} />

        <Spacer height={1.5} />
        <H3 variant="primary" stack="tiny">
          <FormattedMessage defaultMessage="Need help?" />
        </H3>
        <ArrowLink to={Paths.TALK_TO_CARROT}>
          <FormattedMessage defaultMessage="Talk to Carrot" />
        </ArrowLink>
      </RoundedRectangle>
    </>
  )
}

export { SupportModule }
